import { useCallback } from 'react'
import {
  ApiGetWithToken,
	ApiPostWithToken,
	ApiPatchWithToken,
	ApiDeleteWithToken,
	useApiFetch,
	useApiPost
} from 'shared/api'
import {
	searchsAuthorApiBy
} from 'interface/endpoints'
import {
	ApproachFormData,
  ApproachResult,
  ApproachResultList
} from './types'

export * from './types'

export const useListApproach = (
	searchId: number | null | undefined,
	authorId: number | null | undefined
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!searchId || !authorId) return null
      return ApiGetWithToken<ApproachResultList>(
        apiAccess,
        searchsAuthorApiBy(searchId, authorId, '/approach/list'),
        cancelToken
      )
    },
		[searchId, authorId]
	)
)

export const usePostApproach = (
	searchId: number,
	authorId: number,
  callback?: {
    onPosted?: (result: ApproachResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<ApproachFormData, ApproachResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        searchsAuthorApiBy(searchId, authorId, '/approach'),
				form,
				cancelToken,
				webSocketId
			)
		},
		[searchId, authorId]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useEditApproach = (
	searchId: number,
	authorId: number,
  callback?: {
    onEditted?: (result: ApproachResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<{ approachId: number, form: ApproachFormData }, ApproachResult>(
	useCallback(
		(apiAccess, cancelToken, { approachId, form }, webSocketId) => {
			return ApiPatchWithToken(
				apiAccess,
        searchsAuthorApiBy(searchId, authorId, `/approach/${approachId}`),
				form,
				cancelToken,
				webSocketId
			)
		},
		[searchId, authorId]
	),
	useCallback(
		(result) => {
			if (callback?.onEditted) callback.onEditted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useDeleteApproach = (
	searchId: number,
	authorId: number,
  callback?: {
    onDeleted?: (approachId: number) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<number, number>(
	useCallback(
		(apiAccess, cancelToken, approachId, webSocketId) => {
			return ApiDeleteWithToken(
				apiAccess,
        searchsAuthorApiBy(searchId, authorId, `/approach/${approachId}`),
				cancelToken,
				webSocketId
			)
		},
		[searchId, authorId]
	),
	useCallback(
		(result) => {
			if (callback?.onDeleted) callback.onDeleted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)
